import './compound'
import './martingale'
import './laddermartingale'
import './oscarsgrind'
import './recover'
import './equilibrium'
import './smartmartingale'
import './binarymartingale'
import './profitcompound'
import './masaniello'
import './martingalelist'
import './stakelist'


// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/moneymanagements/index.js